// Helper function to get required env variable
const getEnvVar = (key) => {
    const value = process.env[key];
    if (!value) {
        throw new Error(`Missing required environment variable: ${key}`);
    }
    return value;
};

// Helper function to get optional env variable
const getOptionalEnvVar = (key, defaultValue = '') => {
    return process.env[key] || defaultValue;
};

export const Credentials = {
    // EMAIL JS (OPTIONAL)
    EMAILJS_SERVICE_ID: getOptionalEnvVar('REACT_APP_EMAILJS_SERVICE_ID'),
    EMAILJS_REQUEST_TEMPLATE_ID: getOptionalEnvVar('REACT_APP_EMAILJS_REQUEST_TEMPLATE_ID'),
    EMAILJS_ANSWER_TEMPLATE_ID: getOptionalEnvVar('REACT_APP_EMAILJS_ANSWER_TEMPLATE_ID'),
    EMAILJS_PUBLIC_KEY: getOptionalEnvVar('REACT_APP_EMAILJS_PUBLIC_KEY'),

    // RECAPTCHA (OPTIONAL)
    RECAPTCHA_SITE_KEY: getOptionalEnvVar('REACT_APP_RECAPTCHA_SITE_KEY'),

    // FIREBASE (fielcarga project) - REQUIRED
    FIREBASE_API_KEY: getEnvVar('REACT_APP_FIREBASE_API_KEY'),
    FIREBASE_AUTH_DOMAIN: getEnvVar('REACT_APP_FIREBASE_AUTH_DOMAIN'),
    FIREBASE_PROJECT_ID: getEnvVar('REACT_APP_FIREBASE_PROJECT_ID'),
    FIREBASE_STORAGE_BUCKET: getEnvVar('REACT_APP_FIREBASE_STORAGE_BUCKET'),
    FIREBASE_MESSAGING_SENDER_ID: getEnvVar('REACT_APP_FIREBASE_MESSAGING_SENDER_ID'),
    FIREBASE_APP_ID: getEnvVar('REACT_APP_FIREBASE_APP_ID'),
    FIREBASE_MEASUREMENT_ID: getEnvVar('REACT_APP_FIREBASE_MEASUREMENT_ID'),

    // META PIXEL (OPTIONAL)
    META_PIXEL_ID: getOptionalEnvVar('REACT_APP_META_PIXEL_ID'),

    // EMAIL SENDING via Resend (OPTIONAL - for email sending)
    // API key is handled server-side via Cloud Functions for security
    EMAIL_CLOUD_FUNCTION_URL: getOptionalEnvVar('REACT_APP_EMAIL_CLOUD_FUNCTION_URL', ''),
    EMAIL_SENDER_EMAIL: getOptionalEnvVar('REACT_APP_EMAIL_SENDER_EMAIL', 'noreply@fielcarga.pt'),
    EMAIL_RECEIVER_EMAIL: getOptionalEnvVar('REACT_APP_EMAIL_RECEIVER_EMAIL', 'geral@fielcarga.pt')
};
